module.exports = __webpack_public_path__ + "img/1.fa986fd9.png";